import { put } from '..';

const updateUserGroup = (id: string, name: string, description: string) => put(
  'users/v2/user-groups',
  {
    id,
    name,
    description,
  },
);

export default updateUserGroup;
